import React, { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import './BottomNav.css';
import { itemsWord } from '../utils/pluralize';

// Icons
const HomeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 22V12H15V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const HeartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.388 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.512 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99871 7.05 2.99871C5.59096 2.99871 4.19169 3.57831 3.16 4.61C2.12831 5.64169 1.54871 7.04097 1.54871 8.5C1.54871 9.95903 2.12831 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7563 11.2728 22.0329 10.6054C22.3095 9.93801 22.4518 9.22249 22.4518 8.5C22.4518 7.77751 22.3095 7.06199 22.0329 6.39462C21.7563 5.72725 21.351 5.12084 20.84 4.61Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const CartIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 22C9.55228 22 10 21.5523 10 21C10 20.4477 9.55228 20 9 20C8.44772 20 8 20.4477 8 21C8 21.5523 8.44772 22 9 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M20 22C20.5523 22 21 21.5523 21 21C21 20.4477 20.5523 20 20 20C19.4477 20 19 20.4477 19 21C19 21.5523 19.4477 22 20 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1 1H5L7.68 14.39C7.77144 14.8504 8.02191 15.264 8.38755 15.5583C8.75318 15.8526 9.2107 16.009 9.68 16H19.4C19.8693 16.009 20.3268 15.8526 20.6925 15.5583C21.0581 15.264 21.3086 14.8504 21.4 14.39L23 6H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const OrdersIcon = () => (
  // package / parcel (same outline family and 2px rounded stroke as the other nav icons)
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.27 6.96L12 12.01L20.73 6.96" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 22.08V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const UserIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const BottomNav = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const [cartTotal, setCartTotal] = useState(0);
  const [cartItems, setCartItems] = useState([]);

  // Fetch cart data when on cart page or when cart changes
  useEffect(() => {
    if (isAuthenticated) {
      fetchCartData();
    }
  }, [location.pathname, isAuthenticated]);

  // Listen for cart updates
  useEffect(() => {
    const handleCartUpdate = () => {
      if (isAuthenticated) {
        fetchCartData();
      }
    };

    window.addEventListener('cartUpdated', handleCartUpdate);
    return () => {
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, [isAuthenticated]);

  const fetchCartData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/products?cart=true`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      if (response.ok) {
        const products = await response.json();
        setCartItems(products);
        // Calculate total the same way as CartPage
        let total = 0;
        products.forEach((product) => {
          const quantity = product.chosen_variation?.quantity || 1;
          const variation = product.chosen_variation || 
            product.product_variations?.find(v => v.main) || 
            product.product_variations?.[0];
          if (variation && variation.price) {
            total += parseFloat(variation.price) * quantity;
          }
        });
        setCartTotal(total);
      }
    } catch (error) {
      console.error('Error fetching cart data:', error);
    }
  };

  const handleNavigation = (path) => {
    if (path === '/favorites' || path === '/cart' || path === '/orders') {
      if (isAuthenticated) {
        navigate(path);
      } else {
        window.dispatchEvent(new CustomEvent('openAuthPopup'));
      }
    } else {
      navigate(path);
    }
  };

  const handleCheckout = () => {
    if (location.pathname === '/checkout') {
      // On checkout page, trigger form submission
      const form = document.querySelector('.checkout__form');
      if (form) {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    } else {
      // On cart page, navigate to checkout
      navigate('/checkout');
    }
  };

  const isCartPage = location.pathname === '/cart';
  const isCheckoutPage = location.pathname === '/checkout';

  const cartCount = cartItems.reduce((sum, product) => sum + (product.chosen_variation?.quantity || 1), 0);
  
  // Update profile button to navigate to account page if authenticated
  const handleProfileClick = async () => {
    if (isAuthenticated) {
      navigate('/account');
    } else {
      window.dispatchEvent(new CustomEvent('openAuthPopup'));
    }
  };

  return (
    <nav className={`bottom-nav ${isCartPage || isCheckoutPage ? 'bottom-nav--cart' : ''}`}>
      {(isCartPage || isCheckoutPage) && cartItems.length > 0 && (
        <div className="bottom-nav__cart-row">
          <div className="bottom-nav__cart-total">
            <span className="bottom-nav__cart-label">
              Всього
              <span className="bottom-nav__cart-count"> · {cartCount} {itemsWord(cartCount)}</span>
            </span>
            <span className="bottom-nav__cart-amount">
              {cartTotal % 1 === 0 ? cartTotal.toString() : cartTotal.toFixed(2)}
              <span className="bottom-nav__cart-currency"> ₴</span>
            </span>
          </div>
          <button
            className="bottom-nav__cart-button"
            onClick={handleCheckout}
          >
            {isCheckoutPage ? 'Підтвердити' : 'Оформити'}
          </button>
        </div>
      )}
      <div className="bottom-nav__container">
        <button 
          className={`bottom-nav__item ${location.pathname === '/' ? 'active' : ''}`}
          onClick={() => handleNavigation('/')}
          aria-label="Home"
        >
          <HomeIcon />
          <span className="bottom-nav__label">Головна</span>
        </button>
        
        <button 
          className={`bottom-nav__item ${location.pathname === '/favorites' ? 'active' : ''}`}
          onClick={() => handleNavigation('/favorites')}
          aria-label="Favorites"
        >
          <HeartIcon />
          <span className="bottom-nav__label">Обране</span>
        </button>
        
        <button
          className={`bottom-nav__item ${location.pathname === '/cart' ? 'active' : ''}`}
          onClick={() => handleNavigation('/cart')}
          aria-label="Cart"
        >
          <CartIcon />
          {cartItems.length > 0 && (
            <span className="bottom-nav__badge">{cartItems.length}</span>
          )}
          <span className="bottom-nav__label">Кошик</span>
        </button>
        
        <button 
          className={`bottom-nav__item ${location.pathname === '/orders' ? 'active' : ''}`}
          onClick={() => handleNavigation('/orders')}
          aria-label="Orders"
        >
          <OrdersIcon />
          <span className="bottom-nav__label">Замовлення</span>
        </button>
        
        <button 
          className={`bottom-nav__item ${location.pathname === '/profile' || location.pathname === '/account' ? 'active' : ''}`}
          onClick={handleProfileClick}
          aria-label="User"
        >
          <UserIcon />
          <span className="bottom-nav__label">Профіль</span>
        </button>
      </div>
    </nav>
  );
};

export default BottomNav; 